var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.uploaderClass},[_c('DxFileUploader',_vm._g(_vm._b({ref:"dxFileUploader"},'DxFileUploader',_vm.options,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }